import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Icon } from "@iconify/react";
import closeFill from "@iconify/icons-eva/close-fill";
import { useTranslation } from "react-i18next";
import FormDirectionScope from "../../theme/FormDirectionScope";

export default function ComponentPopup({
  openPopup,
  componentToPassDown,
  setOpenPopup,
  title,
  titleKey,
  titleValues,
  paperClass,
  paperSx,
  onClose,
  hideCross,
  maxWidth,
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const resolvedTitle = titleKey ? t(titleKey, titleValues) : title;

  const handleClose = () => {
    setOpenPopup(false);
    onClose?.();
  };

  const paperProps = {
    className: paperClass || "",
    ...(paperSx || maxWidth != null
      ? {
          sx: {
            ...(maxWidth != null && { minWidth: 400, width: "100%" }),
            ...paperSx,
          },
        }
      : {}),
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={openPopup}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      className="mui-component-popup"
      {...(maxWidth != null && { maxWidth })}
      PaperProps={paperProps}
    >
      {(resolvedTitle || !hideCross) && (
        <div className="d-flex justify-content-between align-items-center">
          {resolvedTitle ? (
            <h3 className="mui-component-popup-title">{resolvedTitle}</h3>
          ) : (
            <span style={{ flex: 1 }} aria-hidden="true" />
          )}
          {!hideCross && (
            <button
              type="button"
              className="drawer-cross-icon"
              onClick={handleClose}
              aria-label={t("common.close")}
            >
              <Icon icon={closeFill} width={20} height={20} />
            </button>
          )}
        </div>
      )}
      <div className="show-component-center">
        <FormDirectionScope>{componentToPassDown}</FormDirectionScope>
      </div>
    </Dialog>
  );
}
